<div class="full-height layout-column">
  <div class="col full-height layout-row"
       [ngClass]="{'selected': isSelected}"
       (mouseenter)="onHover(true)"
       (mouseleave)="onHover(false)"
       (click)="onClick($event)">

    <!--  <div *ngIf="item.handle"-->
    <!--    class="drag-handle align-self-center mx-3 my-0"-->
    <!--    dndHandle-->
    <!--    matListItemIcon>-->
    <!--    <bringoz-icon icon-name="account"></bringoz-icon>-->
    <!--  </div>-->

    <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')" class="layout-column">

      <!--        <ng-container>-->
      <!--          <div class="flex layout-column layout-align-start-center margin-left-8 margin-right-10" style="position: relative">-->
      <!--            <div class="drag-wrapper">-->
      <!--              <ng-content></ng-content>-->
      <!--            </div>-->
      <!--            <div class="activity-index"-->
      <!--                 [style.border-color]="routeColor"-->
      <!--                 [style.background]="highlightedActivity?.id === activity.id ? routeColor : (routeColor + 20)"-->
      <!--                 [style.color]="highlightedActivity?.id === activity.id ? 'white' : routeColor">-->
      <!--              <span class="index">{{ index }}</span>-->
      <!--              <span *ngIf="isDisplayRetrips" class="trip-number">{{ activity.tripNumber }}</span>-->
      <!--            </div>-->
      <!--            <div class="flex"></div>-->
      <!--          </div>-->
      <!--        </ng-container>-->

      <ng-container>
        <div *ngIf="isHover || isSmallScreen"
             class="flex layout-column layout-align-start-center margin-left-8 margin-right-10"
             style="position: relative">
          <div class="flex">
            <div class="drag-wrapper">
              <ng-content></ng-content>
            </div>
            <!--          <bringoz-icon iconName="drag" fill="#484848"></bringoz-icon>-->
          </div>
          <div class="activity-index"
               [style.border-color]="routeColor"
               [style.background]="highlightedActivity?.id === activity.id ? routeColor : (routeColor + 20)"
               [style.color]="highlightedActivity?.id === activity.id ? 'white' : routeColor"
          >
            <span class="index">{{ index }}</span>
            <span *ngIf="isDisplayRetrips" class="trip-number">{{ activity.tripNumber }}</span>
          </div>
          <div class="flex"></div>
        </div>

        <div *ngIf="!isHover && !isSmallScreen"
             class="flex layout-column layout-align-start-center margin-left-8 margin-right-10">
          <bringoz-icon *ngIf="route.locked" iconName="lock" classSize="lg"
                        class="margin-bottom-5"
                        fill="#484848"
                        [ngbTooltip]="'Route is Locked' | translate"
                        openDelay="300">
          </bringoz-icon>
          <div class="flex index-border" [style.background-color]="routeColor"></div>
          <div class="activity-index"
               [style.border-color]="routeColor"
               [style.background]="highlightedActivity?.id === activity.id ? routeColor : (routeColor + 20)"
               [style.color]="highlightedActivity?.id === activity.id ? 'white' : routeColor"
          >
            <span class="index">{{ index }}</span>
            <span *ngIf="isDisplayRetrips" class="trip-number">{{ activity.tripNumber }}</span>
          </div>
          <div class="flex index-border" [style.background-color]="routeColor"></div>
        </div>
      </ng-container>

    </div>

    <div class="flex layout-row layout-wrap">

      <!--Link Row-->
      <div class="flex-100 layout-row layout-align-start-center gap-5">
        <app-bringoz-checkbox
          *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
          [isChecked]="isSelected"
          [isIndeterminate]="isIndeterminate"
          [isDisabled]="route?.locked || isRunning"
          [ngbTooltip]="isSelected ? ('Deselect Activity' | translate) : ('Select Activity' | translate)"
          openDelay="300"
          (clickEvent)="onToggle.emit({ item: activity, isSelected: !isSelected })">
        </app-bringoz-checkbox>

        <span *ngIf="activity.type === 'GROUP'"
              class="bundle-header br-body-1"
              [appHighlightText]="queryText"
              [ngClass]="activity.stopType">
          {{ 'Multi' | translate }} {{ activity.stopType | translate }}({{ activity.stopIds.length }})
        </span>

        <span *ngIf="activity.type !== 'GROUP'"
              class="bundle-header br-body-1"
              [appHighlightText]="queryText"
              [ngClass]="activity.stopType">
          {{ activity.stopType | translate }}
        </span>

        <span class="flex"></span>

        <div
          *ngIf="(isShowObligateTimeWindowToggle || isObligatedTimeWindow) && (activity.type !== 'START') && (activity.type !== 'END')"
          type="tertiary"
          class="pointer"
          (mouseenter)="isHighlightObligateTimeWindowToggle=true"
          (mouseleave)="isHighlightObligateTimeWindowToggle=false"
          (click)="onToggleObligateTimeWindow.emit({jobIds: jobIds, obligateTimeWindow: !isObligatedTimeWindow})">

        </div>

        <bringoz-button *ngIf="activity.type === 'GROUP'"
                        type="tertiary"
                        size="fit"
                        (onClick)="isExpanded = !isExpanded">
          <bringoz-icon [iconName]="isExpanded ? 'arrow-up' : 'arrow-down'"
                        classSize="lg"
                        fill="#484848">
          </bringoz-icon>
        </bringoz-button>
      </div>

      <!--Start/End Row-->
      <div *ngIf="(activity.type === 'START') || (activity.type === 'END')"
           [ngClass]="{'flex-100': itemElementSize === 'large', 'flex-50': itemElementSize === 'medium'}"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="location-pin-outline"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="activity.type === 'START' ? ('Start Location' | translate) : ('End Location' | translate)"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1" [appHighlightText]="queryText">{{ 'STOP_PURPOSE.' + activity.type | translate }}</span>
      </div>

      <!--Account Row-->
      <div
        *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
        class="layout-row layout-align-start-center info-row gap-5 flex-100">
        <bringoz-icon iconName="account"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Account' | translate"
                      openDelay="300">

        </bringoz-icon>

        <app-bringoz-items-list-display [appHighlightText]="queryText"
                                        [items]="accountsName"
                                        [isTransparentBackground]="true"
                                        [maxItems]="1">
        </app-bringoz-items-list-display>

      </div>

      <!--Branches Row-->
      <div
        *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
        class="layout-row layout-align-start-center info-row gap-5 flex-100">
        <bringoz-icon iconName="branch"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Branches' | translate"
                      openDelay="300">

        </bringoz-icon>

        <branches-indicator [branches]="details?.branchReferences"></branches-indicator>

      </div>

      <!--Address Row-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')" class="flex-100 layout-row layout-align-start-center info-row gap-5">
        <div class="flex td small layout-row layout-align-start-center"
             (mouseenter)="showAddressIcon=true"
             (mouseleave)="showAddressIcon=false">
          <app-task-purpose [purpose]="activity.stopType" firstLetterOnly="true"></app-task-purpose>
          <span *ngIf="activity.address"
                class="br-body-1 text-ellipsis"
                [appHighlightText]="queryText"
                [ngbTooltip]="activity.address | bringozAddress"
                openDelay="300">{{ activity.address | bringozAddress }}</span>

          <ng-template #locationTooltip>
            <div class="layout-column layout-align-start-center">
              <div class="layout-column layout-align-start-center">
                <span class="br-body-2">{{ 'Address' | translate }}
                  : {{ activity.address | bringozAddress }}</span>
                <div class="layout-column layout-align-start-center">
                <span class="br-body-2">{{ 'Apt' | translate }}: {{
                    activity.address.apartment || '--'
                  }}</span>
                </div>
              </div>
            </div>
          </ng-template>

        </div>
      </div>

      <!--ETA and ETA Row-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="time-window-outline"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Time Window' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis" [appHighlightText]="queryText">{{ {notBefore: activity.eta, notAfter: activity.etd} | timeWindow }}</span>
      </div>

      <!--Skills Row-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="skill-outline"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Skills' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="!activitySkills?.length" class="br-body-1 text-ellipsis">---</span>
        <app-skill-tags class="flex" [skillsIds]="activitySkills" limit="2"></app-skill-tags>
      </div>

      <!--Distance Row-->
      <!--TODO: ask if this is doable with only job data or disable for jobs-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="distance"
                      classSize="lg"
                      fill="#484848"
                      [ngbTooltip]="'Distance From Last Stop' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span
          class="br-body-1 text-ellipsis">{{ activity.distanceFromLastStopMeter | bringozDistance: '---':true }}</span>
      </div>

      <!--Service Time Row-->
      <div
        *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
        [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
        class=" layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="timer-outline"
                      classSize="md"
                      fill="#484848"
                      [ngbTooltip]="'Service Time' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span *ngIf="callServiceTime?.adjustedServiceTime != null"
              class="br-body-1 text-ellipsis">
          {{ callServiceTime.adjustedServiceTime | bringozTimeConvert:true }}
        </span>

        <div class="layout-row layout-align-start-center"
             [ngClass]="{'line-through': callServiceTime?.adjustedServiceTime != null}">
          <span *ngIf="!activity.detailedServiceTime"
                class="br-body-1 text-ellipsis"
                [appHighlightText]="queryText">{{ activity.serviceTime | bringozTimeConvert:true }}</span>

          <app-task-detailed-service-time *ngIf="!!activity.detailedServiceTime"
                                          fontSize="br-body-1"
                                          [isAllowEdit]="false"
                                          [appHighlightText]="queryText"
                                          [detailedServiceTime]="activity.detailedServiceTime">
          </app-task-detailed-service-time>
        </div>

        <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
          <bz-button *ngIf="isServiceTimeEditable"
                     variant="tertiary"
                     size="fit"
                     [disabled]="isDayDispatched"
                     [ariaLabel]="'Edit Service Time' | translate"
                     [ngbTooltip]="(isDayDispatched ? 'VISIT_SCHEDULE_TOOLTIPS.DAY_BLOCKED_DISPATCHED' : 'Edit Service Time') | translate"
                     container="body"
                     openDelay="300"
                     (clicked)="$event.stopPropagation(); onEditServiceTime.emit({callId: details.callId, event: $event})">
            <bz-icon [icon]="icons.editOutline"></bz-icon>
          </bz-button>
        </ng-container>
      </div>

      <!--Travel Time Row-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END')"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="geo-time"
                      classSize="lg"
                      fill="#484848"
                      [ngbTooltip]="'Travel Time From Last Stop' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span
          class="br-body-1 text-ellipsis">{{ activity.travelTimeFromLastStopMillis | bringozTimeConvert:true}}</span>
      </div>

      <!--Delivery Day Row-->
      <!--TODO: ask if this is doable with only job data or disable for jobs-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END') && details?.deliveryDay"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="reaction"
                      classSize="lg"
                      fill="#484848"
                      [ngbTooltip]="'Delivery Day' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ 'Delivery' | translate }} {{ 'ETD' | translate }}:</span>
        <span class="br-body-1 text-ellipsis">{{details | bringozTime: 'deliveryEtd'}}</span>
      </div>

      <!--Delivery Units Row-->
      <!--TODO: ask if this is doable with only job data or disable for jobs-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END') && details?.deliveryDay"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="package-outline"
                      classSize="lg"
                      fill="#484848"
                      [ngbTooltip]="'Delivery Units' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{details.deliveryUnits || '---'}}</span>
      </div>

      <!--Priority Row-->
      <div *ngIf="(activity.type !== 'START') && (activity.type !== 'END') && displaySegment != null"
           [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"
           class="layout-row layout-align-start-center info-row gap-5">
        <bringoz-icon iconName="priority"
                      classSize="lg"
                      fill="#484848"
                      [ngbTooltip]="'Priority' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{'Segment' | translate}}: {{displaySegment}}</span>
      </div>

    </div>

  </div>

  <div *ngIf="isExpanded" class="margin-left-40 layout-column layout-align-start-center full-height gap-5">
    <app-visit-plan-route-tasks-panel-list-item *ngFor="let bundledActivity of activity.stopActivities; let activityIndex = index"
                                                [activity]="bundledActivity"
                                                [jobs]="jobs"
                                                [details]="activityDetailsMap[bundledActivity.id]"
                                                [index]="activityIndex + 1"
                                                [route]="route"
                                                [agentColorMap]="agentColorMap"
                                                [selectedJobIds]="selectedJobIds"
                                                [isSelected]="selectedJobIds.includes(bundledActivity.jobId)"
                                                [settings]="settings"
                                                [highlightedActivity]="highlightedActivity"
                                                [itemElementSize]="itemElementSize"
                                                [isSmallScreen]="isSmallScreen"
                                                [queryText]="queryText"
                                                [callServiceTimeMap]="callServiceTimeMap"
                                                [isDayDispatched]="isDayDispatched"
                                                (onEditServiceTime)="onEditServiceTime.emit($event)"
                                                (onToggle)="onToggle.emit($event)"
                                                (onToggleObligateTimeWindow)="onToggleObligateTimeWindow.emit({jobIds: $event.jobIds, obligateTimeWindow: $event.obligateTimeWindow})"
    >
    </app-visit-plan-route-tasks-panel-list-item>
  </div>
</div>
